module.exports = __webpack_public_path__ + "static/17-3-960d1f87cf398b8e8b03b21c613e2437.jpg";